import { Navigate, Route } from 'react-router-dom'
import { OpportunitiesPage } from '~/@biz_investor/opportunities/OpportunitiesPage'
import { OpportunityPage } from '~/@biz_investor/opportunity-detail/OpportunityPage'
import { PortfolioPage } from '~/@biz_investor/portfolio/PortfolioPage'
import { UserProfilePage } from '~/@biz_common/user-profile/UserProfilePage'
import { InvestmentPage } from '~/@biz_investor/investment/InvestmentPage'
import { LoggedInGuard } from '~/@utils/auth-guard/LoggedInGuard'
import { AddFundsPage } from '~/@biz_investor/add-funds/AddFundsPage'
import { HelpCenterPage } from '~/@biz_common/help-center/HelpCenterPage'
import { DocumentsPage } from '~/@biz_common/documents/DocumentsPage'
import { FaqPage } from '~/@biz_common/faq/FaqPage'
import { CallMePage } from '~/@biz_common/call-me/CallMePage'
import { ContactFormPage } from '~/@biz_common/contact-form/ContactFormPage'
import { ChangePhonePage } from '~/@biz_common/phone-change/ChangePhonePage'
import { ChangePhoneCodePage } from '~/@biz_common/phone-change/ChangePhoneCodePage'

export const InvestorRoutes = () => {
  return (
    <Route element={<LoggedInGuard />}>
      <Route path="" element={<Navigate to="/investor/login" replace />} />
      <Route
        path="portfolio"
        element={<Navigate to="/investor/portfolio/overview" replace />}
      />
      <Route
        path="portfolio/:selectedTab?/add-funds/:investmentId"
        element={<PortfolioPage />}
      />
      <Route path="portfolio/:selectedTab?" element={<PortfolioPage />} />
      <Route
        path="portfolio/:selectedTab?/:investmentId?"
        element={<InvestmentPage />}
      />
      <Route path="opportunities" element={<OpportunitiesPage />} />
      <Route path="opportunities/:slug?" element={<OpportunityPage />} />

      <Route path="faq" element={<FaqPage />} />
      <Route path="user-profile" element={<UserProfilePage />} />
      <Route path="user-profile/documents" element={<DocumentsPage />} />
      <Route path="user-profile/change-phone" element={<ChangePhonePage />} />
      <Route
        path="user-profile/change-phone/code"
        element={<ChangePhoneCodePage />}
      />
      <Route path="add-funds" element={<AddFundsPage />} />

      <Route path="help-center" element={<HelpCenterPage />} />
      <Route path="help-center/call-me" element={<CallMePage />} />
      <Route path="help-center/contact-form" element={<ContactFormPage />} />
    </Route>
  )
}
